export enum TimerEvent {
	START = 'start',
	PAUSE = 'pause',
	TIME = 'time',
	TIME_UPDATE = 'timeUpdate',
	COMPLETE = 'complete'
}
